import { IMetbaseDashboard } from 'features/reporting/types';
import { BaseService } from '../../shared/services/BaseService';

class MetabaseDashboardService extends BaseService<IMetbaseDashboard> {
  constructor() {
    super('dashboards');
  }
}

export const metabaseDashboardService = new MetabaseDashboardService();
